/**
 * @file 活动提供给组件的 context-interface
 *
 * @author aprilcai
 */

import { IActCompContextInterface } from '@tencent/iwan-act-comps-context-interface';
import { Utils, ZoneRoleSelect as SdkZoneRoleSelect, PropertyReceive } from '@tencent/iwan-act-comps-sdk';
import { svelteReportDirective } from '../wrapper-component/utils/report';

type IPageActCompContextInterface = IActCompContextInterface & {
  actVm: {
    addContainer: Function;
    addPop: Function;
    addComponent: Function;
  }
};

const ZoneRoleSelect = (originParams: Record<string, any>) => {
  SdkZoneRoleSelect({
    ...originParams,
    confirmCb: (params: any) => {
      originParams.confirmCb?.({
        ...params,
        format: {
          ...params,
        },
      });
    },
  });
};

// 设置物品领取的区服选择组件
PropertyReceive.customZoneRoleSelect = ZoneRoleSelect;

const actCompContextInterface: IPageActCompContextInterface = {
  scene: 'act',
  bridge: {},
  toast: () => {},
  openPage: () => {},
  authHandle: () => Promise.resolve(false),
  // TODO: 要考虑 PC 端区服选择
  // @ts-ignore
  ZoneRoleSelect,
  loginReady: () => Promise.resolve(),
  checkLogin: () => Promise.resolve(false),
  isTestEnv: false,
  inMagic: false,
  switchLogin: () => {},
  attaIWAction: Utils.attaIWAction,
  on: () => {},
  emit: () => {},
  off: () => {},
  actVm: {
    addContainer: () => {},
    addPop: () => {},
    addComponent: () => {},
  },
  reporter: {
    click: () => {},
    expose: () => {},
    report: () => {},
  },
  reportDirective: () => {},
};

let context: Map<string, any>;
/**
 * 获取 contextInterface
 *
 * @returns ContextInterface
 */
export const getActCompContext = () => {
  if (context) {
    return context;
  }
  context = new Map();
  Object.keys(actCompContextInterface).forEach((key) => {
    context.set(key, actCompContextInterface[key as keyof IPageActCompContextInterface]);
  });
  return context;
};

export const getActCompContextInterface = () => actCompContextInterface;

/**
 * 初始化 contextInterface
 *
 * @param Vue
 */
export const initActCompContextInterface = (Vue: any, vueApp: any) => {
  let toastInstance: any;
  const toast = (data: any) => {
    console.log('[sca] toast', data);
    let message = '';
    let duration = 3000;

    if (typeof data === 'string') {
      message = data;
    } else {
      message = data.text;
      duration = data.duration;
    }

    toastInstance?.close();

    toastInstance = Vue.prototype.toast({
      message,
      duration,
    });
  };

  // 兼容原来的 context-interface
  toast.clear = () => {
    toastInstance?.close();
  };

  // Vue.prototype 上的原型方法
  setActCompContextInterface('inMagic', Vue.prototype.inMagic);
  setActCompContextInterface('bridge', Vue.prototype.tvfJsapi || {});
  setActCompContextInterface('toast', toast);
  setActCompContextInterface('openPage', Vue.prototype.$openPage || Vue.prototype.$magicOpenUrl || (() => {}));
  setActCompContextInterface('on', Vue.prototype.$bus.$on.bind(Vue.prototype.$bus));
  setActCompContextInterface('emit', Vue.prototype.$bus.$emit.bind(Vue.prototype.$bus));
  setActCompContextInterface('off', Vue.prototype.$bus.$off.bind(Vue.prototype.$bus));
  setActCompContextInterface('reporter', Vue.prototype.$report);
  // 注入大同上报指令
  setActCompContextInterface('reportDirective', svelteReportDirective);
  setActCompContextInterface('authHandle', Vue.prototype.$authHandle);

  if (vueApp) {
    initVueApiToActCompContextInterface(vueApp);
  }

  console.log('[sca] initActCompContextInterface', actCompContextInterface);
};

export const setActCompContextInterface = (key: keyof IPageActCompContextInterface, value: unknown) => {
  actCompContextInterface[key] = value as never;
};

export const initVueApiToActCompContextInterface = (vueApp: any) => {
  // vuex 上的 state，通过 vue mixins 注入
  setActCompContextInterface('loginReady', async () => await vueApp.$store.state.loginReady);
  // vuex 上的 action，通过 vue mixins 注入
  setActCompContextInterface('checkLogin', vueApp.checkLogin || (() => {}));
  setActCompContextInterface('openLogin', vueApp.openLogin || (() => {}));
  setActCompContextInterface('switchLogin', vueApp.switchLogin || (() => {}));
  console.log('[sca] initVueApiToActCompContextInterface', actCompContextInterface);
};

export const setActVmToContextInterface = (actVm: any) => {
  setActCompContextInterface('actVm', actVm);
  console.log('[sca] setActVmToContextInterface', actCompContextInterface);
};
